import React, { useState, useEffect } from 'react';
import { Paper, Grid, withStyles, Dialog } from '@material-ui/core';
import * as Yup from "yup";
import TransportColliForm from './TransportColliForm'
import moment from 'moment';
import { connect } from "react-redux";
import { BackButton, hasPermission } from '../../sc-utilities';
import * as actions from './store/transportColliActions';
import History from "../../../History";
import { snackActions } from '../../sc-utilities/SnackBar';
import AppLogoLoading from '../../sc-logo';
import * as groupActions from "../../sc-group/Group/store/groupActions";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    progress: {
        width: `398px`,
        height: "400px"
    },
    logo: {
        width: "250px",
        margin: "10px"
    }
});

const TransportColliCreate = props => {
    const { classes, activeCustomerID, onListOrders, onCreateTransportColli, loading, translations, permissions, fetchGroups } = props;

    const [data, setData] = useState({
        orders: [],
        loadingData: true
    });
    const [groups, setGroups] = useState(null);

    useEffect(() => {
        const getGroups = async () => {
            const resultGroups = await fetchGroups({ ActiveCustomerID: activeCustomerID });
            if (resultGroups) {
                let groupsToSet = resultGroups.data.map(group => ({ value: group.GroupID, displayValue: group.Name }));
                if (hasPermission(permissions, 'access_all_transport_collies_on_customer')) {
                    groupsToSet = [...groupsToSet, { value: 'n/a', displayValue: 'n/a' }];
                }
                setGroups(groupsToSet);
            }
        }

        if (hasPermission(permissions, 'group_list')) {
            getGroups();
        }
    }, [fetchGroups, activeCustomerID, permissions]);

    useEffect(() => {
        const fetchData = async () => {
            let orders = await onListOrders({
                ActiveCustomerID: activeCustomerID,
                q: { Status: ["new", "scheduled", "in_warehouse", "on_hold"] }
            });
            orders = orders.length > 0 ? orders : [{ value: "none", displayValue: "None" }];
            setData({
                orders: orders,
                loadingData: false
            });
        };
        fetchData();
        return () => { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async data => {
        if (data["Order"] === "none") {
            snackActions.snackBarComponent("Order is required for creating Transport Colli.", "info");
            return;
        }
        if (data["Group"] === "n/a") {
            data["Group"] = null;
        }
        let result = await onCreateTransportColli({ ...data, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    }

    let initialValues = {
        Name: "",
        Description: "",
        Location: "",
        Order: data.orders && data.orders.length > 0 ? data.orders[0].value : 'none',
        ArrivedDate: moment(),
        GroupID: groups?.map(group => group?.value)?.includes('n/a') ? 'n/a' : groups?.[0]?.value ?? null
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Description: Yup.string().required("Required"),
            Location: Yup.string().required("Required"),
            Order: Yup.string().required("Required"),
            ArrivedDate: Yup.date().required("Required")
        },
        FormTitle: translations['create_transport_colli'] || "Create transport colli",
        ButtonSubmit: {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        }
    };

    // Render form
    return (
        <Paper className={classes.root} >
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data.loadingData}
                PaperProps={{
                    classes: {
                        root: classes.paper
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>
            <Grid container spacing={10}>
                <Grid item xs={12}>
                    {BackButton(translations)}
                    <TransportColliForm
                        formSettings={formSettings}
                        initialValues={initialValues}
                        handleSubmit={handleSubmit}
                        orders={data.orders}
                        create={true}
                        loading={loading}
                        translations={translations}
                        groups={groups}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateTransportColli: transportColli => dispatch(actions.createTransportColli(transportColli)),
        onListOrders: (transportColli) => dispatch(actions.listOrders(transportColli)),
        fetchGroups: params => dispatch(groupActions.fetchGroups(params))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(TransportColliCreate));